export class ListResourceAttachmentEventsResponse {
    'events';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "events",
            "baseName": "events",
            "type": "Array<CloudResourceAttachmentEvent>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListResourceAttachmentEventsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
